import React from "react";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import { metrosResources } from "../endpoints";

class DialogAgregarEditarMetro extends React.Component{
    constructor(props) {
        super(props);
            this.state = {
                iniciar: true,
                nombre: props.accion === 'agregar' ? '' : props.metro.nombre_metro || '',
                pasillo: props.pasillo,
                datos: props.datos,
                title: props.title,
                accion: props.accion,
                disableSelect: props.accion === 'agregar',
            };
    };

    handleChange = e =>{
        const { name, value } = e.target;
        
        if (name === 'nombre') {
            if (/^\d*$/.test(value)) { // Solo permite números
                this.setState({ [name]: value });
            }
        } else {
            this.setState({ [name]: value.replace("/", "") });
        }
    }

    handleClick = () =>{
        if(this.state.accion === "agregar"){
            const nombre = this.state.nombre;
            const pasilloId = this.state.pasillo.id.match(/\d+/)[0];

            const metro = {
                descripcion: nombre,
                id_pasillo: pasilloId
            };

            metrosResources.agregarMetro(metro).then(async response => {
                if(response) return await response.json()
            }).then( result => {
                if(result.message){
                    this.setState({
                        iniciar: true,
                        nombre: ''
                    });
                   this.props.refrescar(result.message, result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else{
             const id = this.props.metro.id.match(/\d+/)[0];
             const nombre = this.state.nombre;
             const pasilloId = this.state.pasillo.id.match(/\d+/)[0];
 
             const metro = {
                descripcion: nombre,
                id_pasillo: pasilloId
             };
            metrosResources.editarMetro(id, metro).then(async response => {
                if(response){
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.setState ={
                        iniciar: true,
                    }
                    this.props.refrescar(result.message, result.severity)
                }else{
                    throw new Error('Something went wrong ...');
                }
            
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }

    }

    render() {
        return(
            <Dialog
                open={this.state.iniciar}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <Autocomplete
                                value={this.state.pasillo || ''}
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({value: null})
                                    }
                                    else{
                                        this.setState({pasillo: newValue})
                                    }
                                }}
                                disabled={this.state.disableSelect}
                                options={this.state.datos.filter(pasillo => pasillo.padre === null)}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.nombre + " " + option.numero || ""}
                                getOptionSelected={(option, value) => option.id === value.id} 
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Pasillo" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField type={'text'} autoFocus={true} value={this.state.nombre} name="nombre" label="Numero" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.nombre} variant="contained"  color="primary" onClick={this.handleClick}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarMetro;